var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-default',[_c('article',{staticClass:"content content--margin container template template--navbar-fixed template--content"},[_c('h1',[_vm._v(" Dokumente ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }